export const PROMISES_CONFIG = [
  { address: 'requestsGameGetIndex' },
  { address: 'requestsParamsIndex' },
  { address: 'requestsUserServiceDataGet' },
  { address: 'requestsGetFavoritesProducts' },
  { address: 'requestsGachaList' },
  { address: 'requestsGuessPriceTodayList' },
  { address: 'requestsWishGet' },
  { address: 'requestsShopShopItems' },
];
